export const FILTER_OPTIONS_SELECT_FIRST = "FILTER_OPTIONS_SELECT_FIRST";
export const FILTER_OPTIONS_SELECT_SECOND = "FILTER_OPTIONS_SELECT_SECOND";
export const GET_OPTIONS = "GET_OPTIONS";
export const REVERSE_VALUE_SELECT = "REVERSE_VALUE_SELECT";
export const GET_CCY = "GET_CCY";
export const GET_BASE_CCY = "GET_BASE_CCY";